<template>
  <div class="success-section">
    <v-icon
      icon="mdi-check-circle"
      size="64"
      color="success"
      class="mb-4"
    />
    <p class="text-body-1 text-medium-emphasis">
      {{ t('home.shopCreatedMessage') }}
    </p>
  </div>
</template>

<script setup lang="ts">
// No props needed for this simple success component
import { useI18n } from 'vue-i18n';

const { t } = useI18n()
</script>

<style scoped lang="scss">
.success-section {
  .v-icon {
    animation: successPulse 2s ease-in-out infinite;
  }
}

@keyframes successPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}
</style> 